import { createSlice } from "@reduxjs/toolkit";
import { getTaskMasterList } from "../../reduxApi/admin/TaskMasterReduxApi";

const taskMasterSlice = createSlice({
    name: 'task',
    initialState: {
        status: 'idel',
        isFiltered: false,
        task: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteTaskAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.task.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.task.splice(index, 1);
                }
            });
        },
        updateTaskAction: (state, action) => {
            const index = state.task.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.task.splice(index, 1, { tasks: action.payload })
            }
        },
        addTaskAction: (state, action) => {
            console.log("action--->",action.payload);
            
            const temp = action.payload;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.task.unshift({ tasks: temp }); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getTaskMasterList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getTaskMasterList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.task = action.payload.data.tasks;
            })
    }
})
export const { deleteTaskAction, updateTaskAction, addTaskAction, setFilteredStatus } = taskMasterSlice.actions
export default taskMasterSlice.reducer